export default __webpack_public_path__ + "static/media/tinder-mblarsen.b2dcfc49.jpg";